export default __webpack_public_path__ + "static/media/gedex_black.f640ef00.png";